import { httpClient, httpClientMaster } from '../utils/http.client';
import { API_master_ENDPOINTS as API_ENDPOINTS } from '../config/api.config';

export const masterService = {
  getStateMasters: async (params) => {
    return await httpClientMaster.get(API_ENDPOINTS.MASTERS.LIST, { params });
  },

  getMasterById: async (id) => {
    return await httpClientMaster.get(`${API_ENDPOINTS.MASTERS.DETAIL}/${id}`);
  },

  createMaster: async (masterData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.CREATE, masterData);
  },

  createBulkMasters: async (mastersArray) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.CREATE_BULK, mastersArray);
  },

  updateMaster: async (id, masterData) => {
    return await httpClientMaster.put(`${API_ENDPOINTS.MASTERS.UPDATE}/${id}`, masterData);
  },

  deleteMaster: async (id) => {
    return await httpClientMaster.delete(`${API_ENDPOINTS.MASTERS.DELETE}/${id}`);
  },

  bulkUploadMasters: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  bulkUploadPincodeMasters: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPLOAD_PINCODE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  bulkUpdateChildMasters: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPDATE_CHILD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  bulkUpdateDynamicChildMasters: async (formData, mm_id) => {
    return await httpClientMaster.post(`/v1/excel/updateChildMaster?mm_id=${encodeURIComponent(mm_id)}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  searchMasters: async (searchParams) => {
    return await httpClient.get(API_ENDPOINTS.MASTERS.SEARCH, { params: searchParams });
  },

  dynamicParents: async (params) => {
    return await httpClientMaster.get(API_ENDPOINTS.MASTERS.DYNAMIC_PARENT, { params });
  },

  getDynamicChildren: async (params) => {
    return await httpClientMaster.get(API_ENDPOINTS.MASTERS.DYNAMIC_CHILD, { params });
  },
  patchDynamicChild: async (id, data) => {
    return await httpClientMaster.patch(`${API_ENDPOINTS.MASTERS.DYNAMIC_CHILD}/${id}`, data);
  },

  updateDynamicParent: async (data) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.UPDATE_DYNAMIC_PARENT, data);
  }, 
  getTseBdrMaster: async () => {
    return await httpClientMaster.get(API_ENDPOINTS.MASTERS.TSE_BDR, { params: { sts: 'Active' } });
  },

  getTseBdrByCode: async (tseBdrCode) => {
    return await httpClientMaster.get(`/v1/static-master/getByTseBdrCode?tseBdrCode=${tseBdrCode}`);
  },

  uploadTseBdrExcel: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPLOAD_TSE_BDR, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadHdfcBranchLocation: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPLOAD_HDFC_BRANCH_LOCATION, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadHdfcBranchSubLocation: async (formData) => {
    return await httpClientMaster.post(API_ENDPOINTS.MASTERS.BULK_UPLOAD_HDFC_BRANCH_SUB_LOCATION, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getPinCodeRecords: async (limit = 50, page = 1) => {
    return await httpClientMaster.get('/v1/pincode-details/getPinCodeRecords', {
      params: { limit, page }
    });
  },

  getPinCodeDetails: async (pinCode) => {
    return await httpClientMaster.get('/v1/pincode-details/getPinCodeDetails', {
      params: { pin_code: pinCode }
    });
  },

  updateMasterStatus: async (data) => {
    return await httpClientMaster.post('/v1/main-master/updateMasterStatus', data);
  },

  uploadMasterFile: async (formData) => {
    return await httpClientMaster.post('/v1/excel/uploadExcel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getAllTseBdrMaster: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllTseBdrMaster');
  },

  getAllHdfcBranchLocations: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllHdfcBranchLocations');
  },

  getAllHdfcSubBranchLocations: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllHdfcSubBranchLocations');
  },

  getAllErgoSmCode: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllErgoSmCode');
  },

  getAllSubChannel: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllSubChannel');
  },

  getAllPincode: async () => {
    return await httpClientMaster.get('/v1/static-master/getAllPincode');
  },

  /**
   * Generic function to fetch static master data
   * @param {string} endpoint - The API endpoint
   * @returns {Promise} - API response
   */
  fetchStaticMasterData: async (endpoint) => {
    return await httpClientMaster.get(endpoint);
  },

  /**
   * Generic function to upload/update static master data
   * @param {string} endpoint - The API endpoint
   * @param {object} data - The data to upload
   * @returns {Promise} - API response
   */
  uploadStaticMasterData: async (endpoint, data) => {
    return await httpClientMaster.post(endpoint, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  /**
   * Fetch channel name dropdown data
   * @returns {Promise} - API response
   */
  fetchChannelName: async () => {
    return await httpClientMaster.get(API_ENDPOINTS.MASTERS.FETCH_CHANNEL_NAME, {
      params: { mm_id: 'MM038', status: 1 }
    });
  },

  /**
   * Fetch branch location dropdown data
   * @returns {Promise} - API response
   */
  fetchBranchLocation: async () => {
    try {
      const response = await httpClientMaster.get(API_ENDPOINTS.MASTERS.FETCH_BRANCH_LOCATION, {
        params: { mm_id: 'MM040', status: 1 }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Fetch all IFSC code records
  getAllIfscCodeRecords: async () => {
    try {
      const response = await httpClientMaster.get('/v1/static-master/getAllIfscCodeMasterRecords');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
